import React, {useState, useContext, useEffect, useRef} from "react";

import {View, Text, BackHandler, ScrollView, TextInput}  from 'react-native'

import contexto from '../util/contexto'

import cores from '../util/cores'

import {estilos} from '../util/estilos'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import { useFocusEffect } from '@react-navigation/native';

import { ViewDegradeVertical } from '../componentes/ViewDegradeVertical';

import Botao from '../componentes/Botao'

import {buscarSaldo, saldoAtual as wsSaldoAtual, transacao} from '../ws/ws_saldo'

import {TRANSACAO_TIPO_CREDITO, TRANSACAO_TIPO_DEBITO, 
			MESES, TRANSACAO_NATUREZA_CREDITO_AVULSO, MSG_ERRO_PADRAO, TELA_PRINCIPAL,
			USER_TIPO_PF} from '../util/constantes'

import Combo from '../componentes/Combo'

import {MaskedTextInput} from "react-native-mask-text";

import * as data from '../util/data'

import {carregamento} from '../componentes/Carregamento'

import {semDados} from '../componentes/SemDados'

import * as numeros from '../util/numeros'

import * as texto from '../util/texto'

import RotuloErro from '../componentes/RotuloErro'

import {buscarEnderecos, novoEndereco as wsNovoEndereco} from '../ws/ws_enderecos'

import CampoNumero from '../componentes/CampoNumero'

import FormularioEndereco from '../componentes/FormularioEndereco'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import {buscarUsuario as wsBuscarUsuario} from '../ws/ws_usuarios'




export default function TelaFinanceiro(){

	const {valorContexto, setValorContexto} = useContext(contexto);
	
	const navegacao = new useNavigation();

	const [sincronizando, setSincronizando] = useState(true)  
   
	const [listaSaldo, setListaSaldo] = useState([])
	
	const [novo, setNovo] = useState(false)  
	
	const [ano, setAno] = useState(data.getAnoAtual()+"") 
	
	const [mes, setMes] = useState(data.getMesAtual()+"")  
	
	const [msgErro, setMsgErro] = useState(null)
	
	const btPesquisarRef = useRef(null);
	
	const btPagarRef = useRef(null);
	
	const cbMesRef = useRef(null);
	
	const cbEnderecosRef = useRef(null);

	const [listaEnderecos, setListaEnderecos] = useState([])

	const [valor, setValor] = useState(null)
	const [nomeTitular, setNomeTitular] = useState(null)
	const [cpfTitular, setCpfTitular] = useState(null)
	const [numeroCartao, setNumeroCartao] = useState(null)
	const [vencimentoCartao, setVencimentoCartao] = useState(null)
	const [cvvCartao, setCvvCartao] = useState(null)

	const [novoEndereco, setNovoEndereco] = useState(false) 
	
	const formularioEnderecoRef  = useRef(null);
	
	const blockBackRef = useRef(false);
	

	const voltar = () => {
			
		if(blockBackRef.current == true){
					
			setMsgErro(null);
			
			setNovoEndereco(false);

			setNovo(false)
					
			blockBackRef.current = false;
		}
		else
			navegacao.replace(util.processaVoltar())
		
		return true;
	};


	useFocusEffect(React.useCallback(() => {
		
		console.log('TelaFinanceiro');
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
	}, []));
	
	
	const buscarDados= async ()=>{

		console.log('TelaFinanceiro - buscarDados');

		setSincronizando(true)
	
		setNovo(false)

		blockBackRef.current = false;
	
		let itens  = await buscarSaldo(valorContexto.idUsuarioAtual, mes, ano);
   
		if(util.temConteudo(itens))
			setListaSaldo(itens);
		
		let saldo  = await wsSaldoAtual(valorContexto.idUsuarioAtual);
		
		setValorContexto(prevState =>({...prevState, saldoAtual: saldo!=null?saldo.saldo:0}));
		
		let usuario = await wsBuscarUsuario(valorContexto.idUsuarioAtual);

		if(usuario!=null && usuario.tipo == USER_TIPO_PF){

			setNomeTitular(usuario.nome_completo);
			setCpfTitular(usuario.cpf_cnpj);
		}

		setSincronizando(false)
	}


	const pesquisar= async ()=>{

		btPesquisarRef.current.setCarregando(true);	
	
		let mesAux = cbMesRef.current.getSelecionado();
	
		if(mesAux==null){

            pesquisarErro("Selecione o mês.");
            return;
        } 
	
		if(texto.isBlanck(ano)){

            pesquisarErro("Informe o ano.");
            return;
        } 
	
		let itens  = await buscarSaldo(valorContexto.idUsuarioAtual, mesAux, ano);
   
		if(util.temConteudo(itens))
			setListaSaldo(itens);
		else
			setListaSaldo([]);
		
		setMsgErro(null);
		
		btPesquisarRef.current.setCarregando(false)
	}


	const pesquisarErro=(mensagem)=>{
		
        btPesquisarRef.current.setCarregando(false)
		setMsgErro(mensagem);
    }


	function getTipo(tipo){
		
		if(tipo == TRANSACAO_TIPO_CREDITO)
			return "Crédito";
		
		if(tipo == TRANSACAO_TIPO_DEBITO)
			return "Débito";
		
		return null;
	}
	
	
	const prepararCredito = async ()=>{
		
		console.log('TelaFinanceiro - prepararCredito');

		setSincronizando(true)
		
		setNovo(true)
	
		blockBackRef.current = true;

		configurarEnderecos();
		
		setSincronizando(false)
	}
	
	
	const configurarEnderecos= async ()=>{
		
		let itens  = await buscarEnderecos(valorContexto.idUsuarioAtual);
   
		setListaEnderecos([])
   
		if(util.temConteudo(itens)){
			
			let retorno = [];

			itens.forEach((item) => {
					retorno.push({"id": item.id, 
					"nome": util.getDescricaoTipoEndereco(item.tipo)+" - "+
						item.logradouro+" "+item.logradouro+" "+item.bairro+" "+item.cidade_nome+" "+item.uf,
						"logradouro": item.logradouro,
							"numero": item.numero,
								"bairro": item.bairro,
									"cep": item.cep,
										"cidade": item.cidade_nome,
											"uf": item.uf});
			});
			
			setListaEnderecos(retorno);
		}
	}
	
	
	const prepararFormularioEndereco= async ()=>{
	
		console.log("prepararEndereco");
	
		if(novoEndereco==true && formularioEnderecoRef.current!=null)	
			formularioEnderecoRef.current.setDados(valorContexto.idUsuarioAtual, null);
	}
	
	
	useEffect(() => {prepararFormularioEndereco()}, [novoEndereco]);
	
	
	async function salvarEndereco(dados){
		
		dados['id_usuario'] = valorContexto.idUsuarioAtual;
		
		let retorno = await wsNovoEndereco(dados);
	
        if( retorno==null || retorno.id==null){
                
            formularioEnderecoRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }

        formularioEnderecoRef.current.salvarSucesso();
		
		configurarEnderecos();
		
		setNovoEndereco(false)
    }


	const prepararEndereco= async ()=>{
	
		console.log("prepararEndereco");
	
		if(novo==true && cbEnderecosRef.current!=null)	
			cbEnderecosRef.current.setDados(listaEnderecos);
	}
	
	
	useEffect(() => {prepararEndereco()}, [novo, listaEnderecos]);


	async function realizarPagamento(){
		
		btPagarRef.current.setCarregando(true)
		
		setMsgErro(null);
		
		if(texto.isBlanck(valor)){

            realizarPagamentoErro("Informe o valor a ser creditado.");
            return;
        } 
	
		if(texto.isBlanck(nomeTitular)){

            realizarPagamentoErro("Informe o nome do titular.");
            return;
        } 
		
		if(texto.isBlanck(cpfTitular) || cpfTitular.length!=11){

            realizarPagamentoErro("Informe o CPF do titular.");
            return;
        } 
		
		if(texto.isBlanck(numeroCartao) || numeroCartao.length!=16){

            realizarPagamentoErro("Informe o número do cartão.");
            return;
        } 
		
		if(texto.isBlanck(vencimentoCartao) || vencimentoCartao.length!=6){

            realizarPagamentoErro("Informe o vencimento do cartão (mm/aaaa).");
            return;
        }
		
		if(texto.isBlanck(cvvCartao) || cvvCartao.length!=3){

            realizarPagamentoErro("Informe o CVV.");
            return;
        }
		
		let endereco = cbEnderecosRef.current.getItemSelecionado();
		
		if(endereco==null){

            realizarPagamentoErro("Selecione o endereço de cobrança.");
            return;
        } 
	
		let retorno = await transacao({"id_usuario": valorContexto.idUsuarioAtual,
										"valor": valor, 
										"tipo": TRANSACAO_TIPO_CREDITO,
										"natureza": TRANSACAO_NATUREZA_CREDITO_AVULSO,
										"fk_relacao": null,
										"numero_cartao": numeroCartao,
										"cvv": cvvCartao,
										"vencimento":vencimentoCartao,
										"nome_titular":nomeTitular,
										"cpf_titular":cpfTitular,
										"logradouro": endereco.logradouro,
										"numero": endereco.numero,
										"bairro": endereco.bairro,
										"cep": endereco.cep,
										"cidade": endereco.cidade,
										"uf": endereco.uf});
	
        if( retorno==null || texto.isBlanck(retorno.codigo_transacao)){
             
            realizarPagamentoErro(retorno.mensagem);
            return;
        }

		setAno(data.getAnoAtual()+"") 
	
		setMes(data.getMesAtual()+"")  
		
		buscarDados();
	}


	const realizarPagamentoErro=(mensagem)=>{
		
        btPagarRef.current.setCarregando(false)
		setMsgErro(mensagem);
    }
	
	
	return (
		<ViewDegradeVertical titulo="Financeiro"  voltar={()=>voltar()}>  
			<Scroll> 
				{ (sincronizando) ?
					(carregamento(sincronizando)):
					(novo?
						formularioCredito():
						(<View style={{flex:1}}> 
							<Bloco>
								<View style={{alignItems:'center'}}>
									<Text style={estilos.rotulo_titulo}>Saldo Atual: {valorContexto.saldoAtual.toString()} pts</Text>
								</View>		
								<View style={{marginTop:5}}/>
								<View style={estilos.separador}/>
								<View style={{marginTop:5}}/>
								<View style={estilos.grade}>
									<View style={[estilos.coluna_dupla, {marginRight:5}]}>
										<Combo 
											rotulo="Mês:" 
											selecionado={MESES[data.getMesAtual()-1]} 
											dados={MESES}
											ref={cbMesRef}/>
									</View>
									<View style={[estilos.coluna]}>
										<Text style={estilos.rotulo_padrao}>Ano:</Text>
										<MaskedTextInput  
											placeholder="" 
											mask="9999"
											style={estilos.campo_padrao} 
											onChangeText={(text, rawText)=>setAno(rawText === ''?null:rawText)}
											keyboardType="numeric"
											value={ano}/>
									</View>
								</View>
								
								<View style={{marginTop:5}}/>	
								
								{util.temConteudo(msgErro) &&
								
									<View style={{alignItems:'center'}}>
										<RotuloErro mensagem={msgErro}/>
									</View>
								}
								
								<View style={{marginTop:5}}/>	
								
								<View style={{alignItems:'center'}}>
									<Botao 
										acao={()=>pesquisar()}
										texto="Pesquisar"
										ref={btPesquisarRef}/>   
								</View>
							</Bloco>
							<View style={{alignItems:'flex-end'}}>
								<Botao 
									acao={()=>prepararCredito()}
									texto="Adicionar Crédito"/>   
							</View>
							{util.temConteudo(listaSaldo)?
								(listaSaldo.map((item, index) =>itemLista(item, index))):
								(<Bloco todaArea={true}> 
									{semDados("info", "Nenhum transação realizada", 60)}
									<View style={{marginTop:10}}/>	
								</Bloco>)
							}
						</View>)
					)				
				}
			</Scroll> 
      	</ViewDegradeVertical>
	); 


	function itemLista(item, index){

		return (
			<Bloco key={index}> 
				<View style={{marginTop:5}}/>
				<View style={estilos.grade}>
					<View style={[estilos.coluna, {alignItems:'flex-start'}]}> 
						<Text style={estilos.rotulo_padrao}>{getTipo(item.tipo)}</Text>
					</View>
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Text style={estilos.rotulo_menor}>{data.converteDataEuaParaBr(item.data_cadastro, false)}</Text>
					</View>
				</View>		
				<View style={{marginTop:5}}/>
				<View style={estilos.grade}>
					<View style={[estilos.coluna]}>
						<Text style={estilos.rotulo_titulo}>R$: {numeros.formataNumeroParaMostrar(item.valor)}</Text>
					</View>	
					<View style={[estilos.coluna, {alignItems:'flex-end'}]}> 
						<Text style={estilos.rotulo_titulo}>{item.pontos} pts</Text>
					</View>	
				</View>		
				<View style={{marginTop:5}}/>
			</Bloco>
		)
	}
	
	
	function formularioCredito(){
		
		return (
			<Scroll> 
				{(novoEndereco)?
					(<FormularioEndereco ref={formularioEnderecoRef} salvar={salvarEndereco}/>):
					(<Bloco todaArea={true}>
						<View style={{marginTop:10}}/>  
						<View style={{alignItems:'center'}}> 
							<Text style={estilos.rotulo_titulo}>Cartão de Crédito</Text>
						</View>	
						<View style={{marginTop:10}}/>
					
						<View style={estilos.grade}>
							<View style={[estilos.coluna_dupla]}>	
								<Text style={estilos.rotulo_padrao}>Valor (R$):</Text>
								<CampoNumero
									valor={valor}
									prefixo="R$: "
									setValor={(valor)=>setValor(valor)}/>
							</View>
							<View style={[estilos.coluna]}/>	
						</View>	
							
						<View style={{marginTop:10}}/>
						
						<Text style={estilos.rotulo_padrao}>Nome do Títular:</Text>
						<TextInput
							placeholder=""
							style={estilos.campo_padrao} 
							multiline={false}
							onChangeText={(text)=>setNomeTitular(text)}
							maxLength={250}
							value={nomeTitular}/>
						
						<View style={{marginTop:10}}/>
						
						<Text style={estilos.rotulo_padrao}>CPF do Títular:</Text>			
						<MaskedTextInput  
							placeholder="" 
							mask="999.999.999-99"
							style={estilos.campo_padrao} 
							onChangeText={(text, rawText)=>setCpfTitular(rawText === ''?null:rawText)}
							keyboardType="numeric"
							value={cpfTitular}/>
						
						<View style={{marginTop:10}}/>
						
						<Text style={estilos.rotulo_padrao}>Número de Cartão:</Text>			
						<MaskedTextInput  
							placeholder="" 
							mask="9999 9999 9999 9999"
							style={estilos.campo_padrao} 
							onChangeText={(text, rawText)=>setNumeroCartao(rawText === ''?null:rawText)}
							keyboardType="numeric"
							value={numeroCartao}/>
							
						<View style={{marginTop:10}}/>
						
						<View style={estilos.grade}>
							<View style={[estilos.coluna]}>	
								<Text style={estilos.rotulo_padrao}>Venc. (mm/aaaa):</Text>			
								<MaskedTextInput  
									placeholder="" 
									mask="99/9999"
									style={estilos.campo_padrao} 
									onChangeText={(text, rawText)=>setVencimentoCartao(rawText === ''?null:rawText)}
									keyboardType="numeric"
									value={vencimentoCartao}/>
							</View>
							<View style={[estilos.coluna, {marginLeft:10}]}>	
								<Text style={estilos.rotulo_padrao}>CVV:</Text>			
								<MaskedTextInput  
									placeholder="" 
									mask="999"
									style={estilos.campo_padrao} 
									onChangeText={(text, rawText)=>setCvvCartao(rawText === ''?null:rawText)}
									keyboardType="numeric"
									value={cvvCartao}/>
							</View>
						</View>
						
						<View style={{marginTop:10}}/>  
						<View style={{alignItems:'center'}}> 
							<Text style={estilos.rotulo_titulo}>Endereço de Cobrança</Text>
						</View>	
						<View style={{marginTop:10}}/>
						<Combo 
							rotulo="Endereço:" 
							dados={listaEnderecos}
							ref={cbEnderecosRef}/>
								
						<View style={{marginTop:10}}/>
								
						<View style={{alignItems:'center'}}>
							<Botao
								acao={()=>setNovoEndereco(true)}
								texto="Novo Endereço"
								somente_texto={true}
								cor={cores.azul}/>    
						</View>
								
						<View style={{marginTop:20}}/>
						<View style={estilos.separador}/>
						<View style={{marginTop:20}}/>
							
						{util.temConteudo(msgErro) &&
							<View style={{alignItems:'center'}}>
								<RotuloErro mensagem={msgErro}/>
							</View>
						}
							
						<View style={{alignItems:'center'}}>
							<Botao 
								acao={()=>realizarPagamento()}
								texto="Realizar Pagamento"
								ref={btPagarRef}/>   
						</View>
					</Bloco>)	
				}
			</Scroll>
		)
	}
}
